import AppConfig from '@/config'

export type Tenant = 'pomogai' | 'MTSPRO' | 'MTSBY' | 'tcell'

export const tenant = AppConfig.tenant as Tenant
export const isTcell = tenant === 'tcell'
export const isMts = AppConfig.isMts // 'MTSPRO' | 'MTSBY' — оставляем как есть
export const isByLocal = AppConfig.local === 'BY'
export const brandName = (): string => (isTcell ? 'TCellGPT' : 'PomogAI')
